// From https://github.com/bloodyowl/scroll
// Note: npm package bloody-scroll `v1.0.1` is broken
// (missing some parenthesis in the transpiled build: https://github.com/bloodyowl/scroll/blob/master/src/index.js#L8)

import raf from 'raf';

const createAnimation = (func, duration = 300) =>
  new Promise<void>((resolve) => {
    const startDate = Date.now();
    const tick = () => {
      const progress = Math.min(1, (Date.now() - startDate) / duration);
      func(progress);
      if (progress < 1) {
        raf(tick);
      } else {
        resolve(undefined);
      }
    };
    tick();
  });

const scroll = ({ x = window.pageXOffset, y = window.pageYOffset }, duration) => {
  const initialTop = window.pageYOffset;
  const initialLeft = window.pageXOffset;
  return createAnimation((progress) => {
    window.scrollTo(
      (1 - progress) * initialLeft + x * progress,
      (1 - progress) * initialTop + y * progress,
    );
  }, duration);
};

export default scroll;
